import React, { useEffect, useState } from "react";
import ReusableModal from "../../../ExtraComponent/ReusableModal";
import Swal from "sweetalert2";
import {
  adminDetails,
  addFund,
  closePanel,
  updateAdmin,
  pm2Reload,
  allClientListDetails,
  superToAdminPermission,
  superToAdminBrokerPermission,
  superToAdminGetNewPermission,
  seeAllSubAdminList,
  deleteSubAdminData,
  superadminCoupon,
  UpdateUserData,
  DeleteUserData,
} from "../../CommonAPI/SuperAdmin";
import GridExample from "../../../ExtraComponent/CommanDataTable";
import {
  SquarePen,
  RotateCcw,
  Eye,
  UserPlus,
  Earth,
  UserSearch,
  Trash2,
  BadgePercent,
} from "lucide-react";
import { useFormik } from "formik";
import AddForm from "../../../ExtraComponent/FormData";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";
import { Edit2, Save } from "lucide-react";

const Strategygroup = () => {
  const [getAdminDetails, setAdminDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [index, setIndex] = useState("");
  const [amount, setAmount] = useState("");
  const [showUpdate, setShowUpdate] = useState(false);
  const [singleAdminData, setSingleAdminData] = useState([]);

  const [showBroker1, setShowAddBroker1] = useState(false);
  const [showPermission1, setShowAddPermission1] = useState(false);
  const [allClientList, setAllClientList] = useState([]);
  const [companyName, setCompanyName] = useState(""); // State to store company name
  const [showAllClientList, setShowAllClientList] = useState(null);
  const [allSubAdminList, setAllSubAdminList] = useState([]);
  const [showAllSubAdminList, setShowAllSubAdminList] = useState(false);
  const [editId, setEditId] = useState(null);
  const [UpdateField, setUpdateField] = useState({
    Username: "",
    Mobile_No: "",
    SignEmail: "",
  });
  const [searchTerm, setSearchTerm] = useState("");


  const [permissionArray, setPermissionArray] = useState([
    {
      value: "MT4Trade",
      label: "MT4Trade",
    },
    { value: "SignalGenerating", label: "Signal Generating" },
    { value: "MakeStrategy", label: "Make Strategy" },
  ]);

  const [offerData, setOfferData] = useState({
    Durtion: "",
    Price: "",
    OfferPrice: "",
    Companyname: "",
  });
  const [showOfferModal, setShowOfferModal] = useState(false);

  const durationOptions = [
    { value: "One_Month", label: "One Month" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Half_Yearly", label: "Half Yearly" },
    { value: "Yearly", label: "Yearly" },
  ];

  const handleCoupon = (tableMeta) => {
    setOfferData({
      ...offerData,
      Companyname: tableMeta.rowData[1],
    });
    setShowOfferModal(true);
  };

  const handleDeleteUser = (userId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await DeleteUserData({
          Companyname: showAllClientList,
          Username: userId,
        });
        if (res.Status) {
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          // Refresh user list or perform any other necessary actions
        } else {
          Swal.fire("Error!", "There was an error deleting the user.", "error");
        }
      }
    });
  };

  const HandleUpdateUser = async (client) => {
    const res = await UpdateUserData({
      Companyname: showAllClientList,

      Username: UpdateField.Username || client.username,

      mobile_no: UpdateField.Mobile_No || client.Mobile_No,

      SignEmail: UpdateField.SignEmail || client.EmailId,
    });
    if (res.Status) {
      Swal.fire("Updated!", "User details have been updated.", "success");
      // Refresh user list or perform any other necessary actions
    } else {
      Swal.fire("Error!", "There was an error updating the user.", "error");
    }
  };

  const handleOfferSubmit = async () => {
    const res = await superadminCoupon(offerData);
    if (res.Status) {
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Success!",
        text: res.message,
        icon: "success",
        timer: 2000,
      });
    } else {
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        title: "Error!",
        text: res.message,
        icon: "error",
        timer: 2000,
      });
    }

    setShowOfferModal(false); // Close modal
  };

  useEffect(() => {
    adminDetailsData();
  }, [searchTerm]);

  const adminDetailsData = async () => {
    await adminDetails()
      .then((response) => {
        if (response.Status) {
          if (searchTerm !== "") {
            const filteredData = response.AdminDetails.filter((admin) =>
              admin.Companyname.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setAdminDetails(filteredData);
          } else {
            setAdminDetails(response.AdminDetails);
          }
        } else {
          setAdminDetails([]);
        }
      })
      .catch((err) => {
        console.log("Error in fatching the Dashboard Details", err);
      });
  };

  const handleChangeStatus = (row, e, status) => {
    const index = row.rowIndex;
    let Companyname = getAdminDetails[index].Companyname;

    Swal.fire({
      // background: "#1a1e23 ",
      backdrop: "#121010ba",
      confirmButtonColor: "#1ccc8a",
      title: "Are you sure?",
      text: "You want to change the status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { Companyname: Companyname, status: status ? "On" : "Off" };

        await closePanel(req)
          .then((response) => {
            if (response.Status) {
              adminDetailsData();
              e.target.checked = status;
              Swal.fire({
                // background: "#1a1e23 ",
                backdrop: "#121010ba",
                confirmButtonColor: "#1ccc8a",
                title: "Changed!",
                text: "Your status has been changed.",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
              });
            }
          })
          .catch((error) => {
            console.error("Error updating charge basis:", error);
          });
      } else {
        e.target.checked = !status;
        adminDetailsData();
      }
    });
  };

  const handleChangePm2Reload = (row, e, status) => {
    const index = row.rowIndex;
    let Companyname = getAdminDetails[index].Companyname;

    Swal.fire({
      // background: "#1a1e23 ",
      backdrop: "#121010ba",
      confirmButtonColor: "#1ccc8a",
      title: "Are you sure?",
      text: "You want to Reload server",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { Companyname: Companyname };

        await pm2Reload(req)
          .then((response) => {
            if (response.Status) {
              adminDetailsData();

              Swal.fire({
                // background: "#1a1e23 ",
                backdrop: "#121010ba",
                confirmButtonColor: "#1ccc8a",
                title: "Changed!",
                text: "Your Server has been Reloaded.",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
              });
            }
          })
          .catch((error) => {
            console.error("Error updating charge basis", error);
          });
      } else {
        adminDetailsData();
      }
    });
  };

  const handleUpdate = (tableMeta) => {
    setShowUpdate(true);
    const index = tableMeta?.rowIndex;
    setSingleAdminData(getAdminDetails[index]);
    setCompanyName(getAdminDetails[index].Companyname);
  };

  //get new permission
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await superToAdminGetNewPermission();
        if (response?.Status) {
          const formattedPermissions = Array.from(
            new Set(response.Data.map((item) => item.NewUpdate)) // Get unique NewUpdate values
          ).map((uniqueValue) => ({
            value: uniqueValue,
            label: uniqueValue,
          }));

          setPermissionArray(formattedPermissions);
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error!",
            text: response.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } catch (error) {
        console.error("Error fetching new permissions", error);
      }
    };
    fetchPermissions();
  }, []);

  // Update Permission function

  // Update broker function
  const handleAddBroker = (tableMeta) => {
    setShowAddBroker1(true);
    const index = tableMeta?.rowIndex;
    setSingleAdminData(getAdminDetails[index]);
    formik1.setFieldValue(
      "BrokerPermission",
      getAdminDetails[index].BrokerPermission || []
    );
  };

  //See All client list api
  const handleClientList = async (tableMeta) => {
    const index = tableMeta.rowIndex; // Get the row index
    const Companyname = getAdminDetails[index].Companyname; // Get the Companyname for the selected row
    setShowAllClientList(Companyname);
    setCompanyName(Companyname); // Save company name for modal title
    try {
      const response = await allClientListDetails(Companyname); // Fetch client list

      setAllClientList(response.Data); // Update the state with fetched data
    } catch (error) {
      setAllClientList([]);
      console.log("Error To Fetch data", error);
    }
  };

  //See All Sub Admin list api
  const handleSubAdminList = async (tableMeta) => {
    setShowAllSubAdminList(true);
    const index = tableMeta.rowIndex; // Get the row index
    const Companyname = getAdminDetails[index].Companyname; // Get the Companyname for the selected row

    setCompanyName(Companyname);
    try {
      const response = await seeAllSubAdminList(Companyname);
      setAllSubAdminList(response.Data || []);
    } catch (error) {
      setAllSubAdminList([]);
      console.log("Error To Fetch data", error);
    }
  };

  //delete sub admin api
  const handleSubAdminDelete = async (Username, tableMeta) => {
    let dataRequest = { Companyname: companyName, Username: Username };
    try {
      const response = await deleteSubAdminData(dataRequest);
      if (response.Status) {
        Swal.fire({
          // background: "#1a1e23 ",
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "Deleted!",
          text: response.message,
          icon: "success",
          timer: 1500,
          timerProgressBar: true,
        });
        setShowAllSubAdminList(false);
      } else {
        Swal.fire({
          // background: "#1a1e23 ",
          backdrop: "#121010ba",
          confirmButtonColor: "#1ccc8a",
          title: "Error!",
          text: response.message,
          icon: "error",
          timer: 1500,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error deleting sub-admin:", error);
    }
  };

  const columns = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const rowIndex = tableMeta.rowIndex;
          return rowIndex + 1;
        },
      },
    },
    {
      name: "Companyname",
      label: "Company Name",
      options: {
        filter: true,
        sort: false,
        width: "20%",
      },
    },
    {
      name: "AddFund",
      label: "Add Fund",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleAddFound(tableMeta)}
            >
              AddFund
            </button>
          );
        },
      },
    },
    {
      name: "Update",
      label: "Update",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <SquarePen
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleUpdate(tableMeta)}
            />
          );
        },
      },
    },
    {
      name: "Add_Permission",
      label: "Add Permission",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Earth
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleAddPermission(tableMeta)}
            />
          );
        },
      },
    },
    {
      name: "Add_Broker",
      label: "Add Broker",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // return <SquarePen size={20} style={{ cursor: "pointer" }} />;
          return (
            <UserPlus
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleAddBroker(tableMeta)}
            />
          );
        },
      },
    },
    {
      name: "All Clients",
      label: "All Clients",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Eye
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleClientList(tableMeta)} // Pass tableMeta
            />
          );
        },
      },
    },

    {
      name: "Add Offer",
      label: "Add Offer",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <BadgePercent
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleCoupon(tableMeta)} // Pass tableMeta
            />
          );
        },
      },
    },
    {
      name: "All SubAdmin",
      label: "All SubAdmin",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <UserSearch
              size={20}
              style={{ cursor: "pointer" }}
              onClick={() => handleSubAdminList(tableMeta)} // Pass tableMeta
            />
          );
        },
      },
    },

    // {
    //     name: "username",
    //     label: "Username",
    //     options: {
    //         filter: true,
    //         sort: false,
    //     }
    // },
    // {
    //     name: "password",
    //     label: "Password",
    //     options: {
    //         filter: true,
    //         sort: false,
    //         customBodyRender: (value, tableMeta, updateValue) => {
    //             return "********";
    //         }

    //     }
    // },
    {
      name: "SignEmail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "SignMobileNo",
      label: "Mobile No",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Create Date",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
      },
    },

    {
      name: "Status",
      label: "Temporary Close Panel",
      options: {
        filter: true,
        sort: false,
        width: "20%",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div className="form-switch">
              <input
                className="form-check-input"
                style={{ cursor: "pointer", width: "61px", height: "27px" }}
                type="checkbox"
                id="flexSwitchCheckDefault"
                // defaultChecked={value == "On" ? true : false}
                checked={value == "On" ? true : false}
                onClick={(e) =>
                  handleChangeStatus(tableMeta, e, e.target.checked)
                }
              />
            </div>
          );
        },
      },
    },
    {
      name: "Status",
      label: "Live Data",
      options: {
        filter: true,
        sort: false,
        width: "20%",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <RotateCcw
              onClick={(e) =>
                handleChangePm2Reload(tableMeta, e, e.target.checked)
              }
            />
          );
        },
      },
    },
    {
      name: "BrokerPermission",
      label: "Broker Permission",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (Array.isArray(value)) {
            let formattedText = value
              .map((item, index) =>
                (index + 1) % 7 === 0 ? item + "\n" : item
              ) // Har 3rd element ke baad new line
              .join(", "); // Comma separated format

            return (
              <pre style={{ whiteSpace: "pre-wrap" }}>{formattedText}</pre>
            );
          }
          return value;
        },
      },
    },
  ];

  const handleAddFound = (index) => {
    setIndex(index.rowIndex);
    setShowModal(true);
  };

  const handleSubmitFund = async () => {
    if (amount === "") {
      Swal.fire({
        // background: "#1a1e23 ",
        backdrop: "#121010ba",
        confirmButtonColor: "#1ccc8a",
        icon: "error",
        title: "Oops...",
        text: "Please enter the amount",
      });
    } else {
      setAmount("");
      setShowModal(false);
    }
    const req = {
      Companyname: getAdminDetails?.[index]?.Companyname,
      AmmountDetails: amount,
    };

    await addFund(req)
      .then((response) => {
        if (response.Status) {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            icon: "success",
            title: "Success",
            text: response.Message,
          });
          adminDetailsData();
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            icon: "error",
            title: "Oops...",
            text: response.Message,
          });
        }
      })
      .catch((err) => {
        console.log("Error in fatching the Dashboard Details", err);
      });
  };

  useEffect(() => {
    formik.setValues({
      Companyname: singleAdminData?.Companyname,
      Username: singleAdminData?.username,
      mobile_no: singleAdminData?.SignMobileNo,
      SignEmail: singleAdminData?.SignEmail,
      Url: singleAdminData?.Url,
      SOPPaperTrade: singleAdminData?.SOPPaperTrade,
      SOPLiveTrade: singleAdminData?.SOPLiveTrade,
      SOPScriptwise: singleAdminData?.SOPScriptwise,
      ChartPerTrade: singleAdminData?.ChartPerTrade,
      ChartPerMonth: singleAdminData?.ChartPerMonth,
      Theme: singleAdminData?.Theme || [],
      Brokername: singleAdminData?.Brokername || "ALICEBLUE",
    });
  }, [singleAdminData]);

  const formik = useFormik({
    initialValues: {
      Companyname: "",
      Username: "",
      mobile_no: "",
      SignEmail: "",
      Url: "",
      SOPPaperTrade: 0.0,
      SOPLiveTrade: 0.0,
      SOPScriptwise: 0.0,
      ChartPaperTrade: 0.0,
      ChartLiveTrade: 0.0,
      ChartPerMonth: 0.0,
      Theme: [],
      Brokername: "ALICEBLUE",
    },
    validate: (values) => {
      let errors = {};

      if (!values.mobile_no) {
        errors.mobile_no = "Please enter mobile number";
      } else if (!/^\d{10}$/.test(values.mobile_no)) {
        errors.mobile_no = "Mobile number must be 10 digits";
      }

      if (!values.SignEmail) {
        errors.SignEmail = "Please enter email";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.SignEmail)
      ) {
        errors.SignEmail = "Invalid email address";
      }

      if (!values.Companyname) {
        errors.Companyname = "Please enter company name";
      }

      if (!values.Username) {
        errors.Username = "Please enter username";
      }

      if (!values.Url) {
        errors.Url = "Please enter a URL";
      } else if (
        !values.Url.startsWith("http://") &&
        !values.Url.startsWith("https://")
      ) {
        errors.Url = "Invalid URL format";
      }

      if (values.SOPPaperTrade < 0) {
        errors.SOPPaperTrade = "Value cannot be negative";
      }
      if (values.SOPLiveTrade < 0) {
        errors.SOPLiveTrade = "Value cannot be negative";
      }
      if (values.SOPScriptwise < 0) {
        errors.SOPScriptwise = "Value cannot be negative";
      }
      if (values.ChartPerTrade < 0) {
        errors.ChartPerTrade = "Value cannot be negative";
      }
      if (values.ChartLiveTrade < 0) {
        errors.ChartLiveTrade = "Please enter Chart Live Trade";
      }
      if (values.ChartPaperTrade < 0) {
        errors.ChartPaperTrade = "Please enter Chart Paper Trade";
      }
      if (values.ChartPerMonth < 0) {
        errors.ChartPerMonth = "Value cannot be negative";
      }

      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        Companyname: values.Companyname || singleAdminData?.Companyname,
        Username: values.Username || singleAdminData?.username,
        mobile_no: values.mobile_no,
        SignEmail: values.SignEmail,
        Url: values.Url,
        SOPPaperTrade: values.SOPPaperTrade || 0,
        SOPLiveTrade: values.SOPLiveTrade || 0,
        SOPScriptwise: values.SOPScriptwise || 0,
        ChartPaperTrade: values.ChartPaperTrade || 0,
        ChartLiveTrade: values.ChartLiveTrade || 0,
        ChartPerMonth: values.ChartPerMonth || 0,
        Theme: values.Theme?.length > 1 ? [values.Theme[0]] : values.Theme,
        Brokername: values.Brokername,
      };

      await updateAdmin(req)
        .then((response) => {
          if (response.Status) {
            Swal.fire({
              background: "#1a1e23",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Admin Updated!",
              text: response.message,
              icon: "success",
              timer: 2000,
              timerProgressBar: true,
            });
            adminDetailsData();
            setShowUpdate(false);
            formik.resetForm();
          } else {
            Swal.fire({
              background: "#1a1e23",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Error!",
              text: response.message,
              icon: "error",
              timer: 2000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          console.log("Error in fetching the Dashboard Details", err);
        });
    },
  });

  const fields = [
    {
      name: "mobile_no",
      label: "Mobile Number",
      type: "text",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
    },
    {
      name: "SignEmail",
      label: "Email",
      type: "text",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
    },
    {
      name: "Url",
      label: "URL",
      type: "text",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: true,
    },
    {
      name: "Companyname",
      label: "Company Name",
      type: "text",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: true,
    },
    {
      name: "Username",
      label: "Username",
      type: "text",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: true,
    },
    {
      name: "SOPPaperTrade",
      label: "Paper Trade Amount(SOP)",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },
    {
      name: "SOPLiveTrade",
      label: "Live Trade Amount(SOP)",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },
    {
      name: "SOPScriptwise",
      label: "Per Script Amount(SOP)",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },
    {
      name: "ChartLiveTrade",
      label: "Chart Live Trade Amount",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },

    {
      name: "ChartPaperTrade",
      label: "Chart Paper Trade Amount",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },

    {
      name: "ChartPerMonth",
      label: "Chart Per Month",
      type: "number",
      label_size: 12,
      hiding: false,
      col_size: 6,
      disable: false,
      defaultValue: 0.0,
    },
    {
      name: "Brokername",
      label: "Admin Broker",
      type: "select",
      label_size: 12,
      col_size: 6,
      disable: false,
      options: [
        { value: "ALICEBLUE", label: "ALICEBLUE" },
        { value: "MARKETHUB", label: "MARKETHUB" },
      ],
    },

    {
      name: "Theme",
      label: "Theme Permission",
      type: "select2",
      label_size: 12,
      col_size: 6,
      disable: false,
      options: [
        { label: "default", value: "default" },
        { label: "Light", value: "Light" },
        { label: "dark", value: "dark" },
        { label: "Mint", value: "Mint" },
        { label: "Sapphire-Gradient", value: "Sapphire-Gradient" },
        { label: "Terra-Stone", value: "Terra-Stone" },
        { label: "Peach-Bloom", value: "Peach-Bloom" },
      ],
    },
  ];

  const formik1 = useFormik({
    initialValues: {
      BrokerPermission: [],
    },

    onSubmit: async (values) => {
      const req = {
        Companyname: singleAdminData?.Companyname,
        
        Brokername: values.BrokerPermission,
      };

      await superToAdminBrokerPermission(req)
        .then((response) => {
          if (response.Status) {
            Swal.fire({
              // background: "#1a1e23 ",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Broker Updated!",
              text: response.message,
              icon: "success",
              timer: 2000,
              timerProgressBar: true,
            });
            adminDetailsData();
            setShowAddBroker1(false);
            formik1.resetForm();
          } else {
            Swal.fire({
              // background: "#1a1e23 ",
              backdrop: "#121010ba",
              confirmButtonColor: "#1ccc8a",
              title: "Error!",
              text: response.message,
              icon: "error",
              timer: 2000,
              timerProgressBar: true,
            });
          }
        })
        .catch((err) => {
          console.log("Error in fatching the Broker Details", err);
        });
    },
  });

  const fields1 = [
    {
      name: "BrokerPermission",
      label: "Broker Permission",
      type: "select2", // Custom dropdown for brokers
      label_size: 12,
      col_size: 6,
      disable: false,
      options: [
    { value: "ICICI", label: "ICICI" },
    { value: "UPSTOX", label: "UPSTOX" },
    { value: "5PAISA", label: "5 PAISA" },
    { value: "ANGEL", label: "ANGEL" },
    { value: "MASTERTRUST", label: "MASTERTRUST" },
    { value: "FYERS", label: "FYERS" },
    { value: "ALICEBLUE", label: "ALICEBLUE" },
    { value: "ZEBULL", label: "ZEBULL" },
    { value: "MANDOT", label: "MANDOT" },
    { value: "INDIRA", label: "INDIRA" },
    { value: "DHAN", label: "DHAN" },
    { value: "MARKETHUB", label: "MARKETHUB" },
    { value: "FINVASIA", label: "FINVASIA" },
    { value: "KOTAK", label: "KOTAK" },
  ],
      value: formik1.values.BrokerPermission, // Bind to formik value
      onChange: (selectedValues) => {
        formik1.setFieldValue("BrokerPermission", selectedValues);
      },
    },
  ];

  //code for update permission
  const formik2 = useFormik({
    initialValues: {
      Permission: [],
    },

    onSubmit: async (values) => {
      const req = {
        Companyname: singleAdminData?.Companyname,
        Permission: values.Permission,
      };
      await superToAdminPermission(req).then((response) => {
        if (response.Status) {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Permission Updated!",
            text: response.message,
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
          });
          adminDetailsData();
          setShowAddPermission1(false);
          formik2.resetForm();
        } else {
          Swal.fire({
            // background: "#1a1e23 ",
            backdrop: "#121010ba",
            confirmButtonColor: "#1ccc8a",
            title: "Error!",
            text: response.message,
            icon: "error",
            timer: 2000,
            timerProgressBar: true,
          });
        }
      });
    },
  });

  const fields2 = [
    {
      name: "Permission",
      label: "Permission",
      type: "select2",
      label_size: 12,
      col_size: 12,
      disable: false,
      options: permissionArray,
      //added data
      value: formik2.values.Permission,
      onChange: (selectedValues) => {
        formik2.setFieldValue("Permission", selectedValues);
      },
    },
  ];
  const handleAddPermission = (tableMeta) => {
    setShowAddPermission1(true);
    const index = tableMeta?.rowIndex;
    setSingleAdminData(getAdminDetails[index]);

    formik2.setFieldValue(
      "Permission",
      getAdminDetails[index].Permission || []
    );
  };

  useEffect(() => {
    if (formik2.values.Permission?.includes("ChartingPlatform")) {
      const updatedPermissions = formik2.values.Permission.filter(
        (item) => item !== "OverallPlan"
      );
      formik2.setFieldValue("Permission", updatedPermissions);
    }
  }, [formik2.values.Permission?.includes("ChartingPlatform")]);

  useEffect(() => {
    if (formik2.values.Permission?.includes("OverallPlan")) {
      // remove "ChartingPlatform" in array
      const updatedPermissions = formik2.values.Permission.filter(
        (item) => item !== "ChartingPlatform"
      );
      formik2.setFieldValue("Permission", updatedPermissions);
    }
  }, [formik2.values.Permission?.includes("OverallPlan")]);

  return (
    <Content
      Page_title={"Admin Details"}
      button_status={false}
      backbutton_status={true}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb iq-bg-primary">
          <li className="breadcrumb-item active" aria-current="page">
            Admin Details
          </li>
        </ol>
      </nav>
      <div className="iq-card-body">
        {/* Search Input */}
        <div className="row mb-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search by Company Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="table-responsive customtable">
          {getAdminDetails.length > 0 ? (
            <GridExample
              columns={columns}
              data={getAdminDetails}
              checkBox={false}
            />
          ) : (
            <NoDataFound />
          )}
        </div>
      </div>

      {/* ------------------- Add Fund Modal ------------------- */}
      <ReusableModal
        show={showModal}
        onClose={() => {
          setAmount("");
          setShowModal(false);
        }}
        title="Add Fund"
        size="md"
        body={
          <div className="mx-4">
            <label className="mt-4">Enter Fund</label>
            <input
              type="number"
              className="form-control mb-4"
              placeholder="Enter Fund"
              onChange={(e) => setAmount(e.target.value)}
              value={amount}
            />
            <div className="d-flex justify-content-end mb-4">
              <button className="btn btn-primary" onClick={handleSubmitFund}>
                Save
              </button>
            </div>
          </div>
        }
      />

      {/* ------------------- Update Admin Modal ------------------- */}
      <ReusableModal
        show={showUpdate}
        onClose={() => {
          setShowUpdate(false);
          formik.resetForm();
        }}
        title={`Update Admin: ${singleAdminData?.Companyname}`}
        size="lg"
        body={<AddForm fields={fields} btn_name="Update" formik={formik} />}
      />

      {/* ------------------- Update Permission Modal ------------------- */}
      <ReusableModal
        show={showPermission1}
        onClose={() => {
          setShowAddPermission1(false);
          formik2.resetForm();
        }}
        title={`Update Permission: ${singleAdminData?.Companyname}`}
        size="md"
        body={<AddForm fields={fields2} btn_name="Update" formik={formik2} />}
      />

      {/* ------------------- Update Broker Modal ------------------- */}
      <ReusableModal
        show={showBroker1}
        onClose={() => {
          setShowAddBroker1(false);
          formik1.resetForm();
        }}
        title={`Update Broker: ${singleAdminData?.Companyname}`}
        size="md"
        body={<AddForm fields={fields1} btn_name="Update" formik={formik1} />}
      />

      {/* ------------------- All Client List Modal ------------------- */}
      <ReusableModal
        show={showAllClientList}
        onClose={() => setShowAllClientList(null)}
        title={`Client List: ${companyName}`}
        size="xl"
        body={
          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th style={{ width: "23%" }}>Username</th>
                  <th style={{ width: "33%" }}>Email</th>
                  <th style={{ width: "33%" }}>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {allClientList?.length > 0 ? (
                  allClientList.map((client, index) => (
                    <tr key={index}>
                      <td>{client.Username}</td>
                      <td>
                        {editId && client.Username === editId ? (
                          <input
                            type="email"
                            defaultValue={
                              UpdateField.SignEmail || client.EmailId
                            }
                            onChange={(e) =>
                              setUpdateField({
                                ...UpdateField,
                                SignEmail: e.target.value,
                                Username: client.Username,
                              })
                            }
                          />
                        ) : (
                          client.EmailId
                        )}
                      </td>
                      <td>
                        {editId && client.Username === editId ? (
                          <input
                            type="text"
                            defaultValue={
                              UpdateField.Mobile_No || client.Mobile_No
                            }
                            onChange={(e) =>
                              setUpdateField({
                                ...UpdateField,
                                Mobile_No: e.target.value,
                                Username: client.Username,
                              })
                            }
                          />
                        ) : (
                          client.Mobile_No
                        )}
                      </td>
                      <td>
                        {editId && client.Username === editId ? (
                          <Save
                            size={18}
                            style={{ cursor: "pointer", marginRight: "8px" }}
                            onClick={() => {
                              HandleUpdateUser(client);
                              setEditId(null);
                            }}
                          />
                        ) : (
                          <Edit2
                            size={18}
                            style={{ cursor: "pointer", marginRight: "8px" }}
                            title="Edit"
                            onClick={() => setEditId(client.Username)}
                          />
                        )}
                        <Trash2
                          size={18}
                          style={{ cursor: "pointer" }}
                          title="Delete"
                          onClick={() =>
                            handleDeleteUser(client.Username, index)
                          }
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No clients found for {singleAdminData?.Companyname}.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        }
      />

      {/* ------------------- All Sub Admin List Modal ------------------- */}
      <ReusableModal
        show={showAllSubAdminList}
        onClose={() => setShowAllSubAdminList(false)}
        title={`Sub Admin List: ${companyName}`}
        size="lg"
        body={
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {allSubAdminList?.length > 0 ? (
                allSubAdminList.map((subAdmin, index) => (
                  <tr key={index}>
                    <td>{subAdmin.Username}</td>
                    <td>{subAdmin.EmailId}</td>
                    <td>{subAdmin.Mobile_No}</td>
                    <td>
                      <button
                        className="btn btn-link p-0"
                        onClick={() =>
                          handleSubAdminDelete(subAdmin.Username, index)
                        }
                      >
                        <Trash2 />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Sub Admin List found for {singleAdminData?.Companyname}.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        }
      />

      {/* ------------------- Add Offer Modal ------------------- */}
      <ReusableModal
        show={showOfferModal}
        onClose={() => setShowOfferModal(false)}
        title={`Add Offer: ${offerData.Companyname}`}
        size="md"
        body={
          <div>
            <div className="mb-3">
              <label className="form-label">Duration</label>
              <select
                className="form-control"
                value={offerData.Durtion}
                onChange={(e) =>
                  setOfferData({ ...offerData, Durtion: e.target.value })
                }
              >
                <option value="" disabled>
                  Select Duration
                </option>
                {durationOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Price</label>
              <input
                type="number"
                className="form-control"
                value={offerData.Price}
                onChange={(e) =>
                  setOfferData({
                    ...offerData,
                    Price: parseFloat(e.target.value),
                  })
                }
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Offer Price</label>
              <input
                type="number"
                className="form-control"
                value={offerData.OfferPrice}
                onChange={(e) =>
                  setOfferData({
                    ...offerData,
                    OfferPrice: parseFloat(e.target.value),
                  })
                }
              />
            </div>
            <div className="d-flex justify-content-end">
              <button className="btn btn-primary" onClick={handleOfferSubmit}>
                Submit
              </button>
            </div>
          </div>
        }
      />
    </Content>
  );
};

export default Strategygroup;
